module.exports = __webpack_public_path__ + "static/media/dialog-photo.dde3b7da.svg";